import { render, staticRenderFns } from "./RelatorioMovimentacao.vue?vue&type=template&id=591d51f1"
import script from "./RelatorioMovimentacao.vue?vue&type=script&lang=js"
export * from "./RelatorioMovimentacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports